import { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api/axiosPublic";
import "../styles/cursoDetalle.css";

export default function CursosDetalle() {
  const { id } = useParams();
  const [curso, setCurso] = useState(null);
  const profesorRef = useRef(null);

  useEffect(() => {
    api.get(`/cursos/${id}`).then(res => setCurso(res.data));
  }, [id]);

  if (!curso) return <p>Cargando curso...</p>;

  const irAProfesor = () => {
    profesorRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="detalle-container">
      <br></br>
      {/* HERO */}
      <div className="detalle-hero">
      {curso.imagen && (
          <img
            src={`https://centromillennials.com/uploads/${curso.imagen}`}
            alt={curso.nombre}
            className="curso-detalle-img"
          />
        )}

        <div className="detalle-info">
          <h1>{curso.nombre}</h1>
          <div className="detalle-texto">
            {curso.descripcion
              .split("\n")
              .map((linea, i) => (
                <p key={i}>{linea}</p>
              ))}
          </div>

          <div className="detalle-precio">
            ${curso.precio}
          </div>

          {curso.fecha_clase && (
            <p className="detalle-fecha">
              📅 {new Date(curso.fecha_clase).toLocaleDateString()} ·
              ⏰ {new Date(curso.fecha_clase).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </p>
          )}

          <p className="detalle-profesor">
            Profesor:{" "}
            <span onClick={irAProfesor}>
              {curso.profesor_nombre}
            </span>
          </p>

          <Link to={`/checkout/${curso.id}`} className="btn-primary">
            Inscribirse
          </Link>
        </div>
      </div>

      {/* PROFESOR */}
      <div ref={profesorRef} className="profesor-section">
      {curso.profesor_foto && (
          <img
            src={`https://centromillennials.com/uploads/profesores/${curso.profesor_foto}`}
            alt={curso.profesor_nombre}
            className="profesor-img"
          />
        )}

        <h2>{curso.profesor_nombre}</h2>
        <div className="detalle-texto">
          {curso.profesor_descripcion
            .split("\n")
            .map((linea, i) => (
              <p key={i}>{linea}</p>
            ))}
        </div>
      </div>
      <br></br>
    </div>
  );
}
